import * as Api from "@api";
import * as C from "@components";
import React from "react";
import { ProductXLSeriesLogo } from "./ProductXLSeriesLogo";
import css from "./product-card.module.scss";
import VadImage from "vadimages-nextjs-image-optimizer";

interface ProductCardProps {
  product: Api.ProductFull;
  transparent?: boolean;
}

const CUSTOM_PRODUCT_IMAGES: Record<string, { link: string }> = {
  "active-axil-mini-pro": { link: "product-thumb.2.png" },
  "active-medley": { link: "product-thumb.1.png" },
  "axil-s1-battery": { link: "axil-s1-product-thumb.png" },
  "offset-s1-battery": { link: "offset-s1-product-thumb.png" },
  "air-pod-postless": { link: "air-pod-product-thumb.png" },
  "pro-pod-ceramic": { link: "pro-pod-product-thumb.png" },
  "classic-pod-stainless": { link: "classic-pod-product-thumb.png" },
  "singular-510-adapter": { link: "510-adapter-product-thumb.png" },
};

export const ProductCard = ({
  transparent,
  product,
}: ProductCardProps): React.FunctionComponentElement<ProductCardProps> => {
  const productLink = product.permalink ?? "#";
  const { link } = CUSTOM_PRODUCT_IMAGES[product.slug] || {
    link: "product-thumb.png",
  };

  const badgeNew = product.descriptor.isNew ? (
    <div className={css["badge-new"]}>New</div>
  ) : null;
  const xlSeriesLogo =
    product.descriptor.series === Api.ProductSeries.XL ? (
      <ProductXLSeriesLogo className={css["xl-series-logo"]} />
    ) : null;

  return (
    <a
      className={`${css["card"]} relative block h-full bg-muted-tan p-6 md:p-9 rounded-default`}
      href={productLink}
      data-product-slug={product.slug}
      data-transparent={transparent ? "" : null}
    >
      {badgeNew !== null && xlSeriesLogo !== null && (
        <div className={css["badges"]}>
          {/* {badgeNew} */}
          <div />
          {xlSeriesLogo}
        </div>
      )}

      <div className="w-full min-h-[220px] flex items-center justify-center mb-5">
        <VadImage
          src={`/images${productLink}/${link}`}
          alt={product.title ?? product.descriptor.title}
          width={150}
          height={220}
        />
      </div>

      <div className="max-md:text-center">
        <C.ProductTitle
          className={css["title"]}
          product={product}
          subTitleContentProps={{ typography: C.Typography.P4 }}
          titleContentProps={{ typography: C.Typography.H5 }}
        />
        <div className={css["description"]}>{product.shortDescription}</div>
        <div className={css["link"]}>View</div>
      </div>
    </a>
  );
};
